<template>
  <template v-if="showProfilePhoto">
    <img :src="userPhoto" @error="profilePhotoError" class="inline-flex items-center justify-center object-cover rounded-full" alt="user-profile-picture" />
  </template>

  <template v-else>
    <span class="inline-flex items-center justify-center bg-gray-500 rounded-full dark:bg-gray-800">
      <span class="text-xs font-light leading-none text-gray-900 dark:text-gray-200">{{ userInitials(`${userFirstName} ${userLastName}`) }}</span>
    </span>
  </template>
</template>

<script>
import { ref } from "@vue/reactivity";
import utilFunctions from "../../composables/util";

export default {
  props: {
    photo: {
      type: String,
    },
    firstName: {
      type: String,
    },
    lastName: {
      type: String,
    },
  },
  components: {},
  setup(props) {
    const { userInitials } = utilFunctions();
    const userPhoto = ref(props.photo);
    const userFirstName = ref(props.firstName);
    const userLastName = ref(props.lastName);

    const showProfilePhoto = userPhoto.value ? ref(true) : ref(false);

    function profilePhotoError() {
      showProfilePhoto.value = false;
    }
    return {
      userPhoto,
      userFirstName,
      userLastName,
      profilePhotoError,
      showProfilePhoto,
      userInitials,
    };
  },
};
</script>
